import { LightningElement, api } from "lwc";
import { logger } from "@devforce/trailhead-client-logger";

import { FormControl } from "./types";
import formControlCombobox from "./formControlCombobox.html";
import formControlSelect from "./formControlSelect.html";
import formControl from "./formControl.html";

export default class extends LightningElement {
  @api config: FormControl | null = null;

  @api
  focus() {
    this.template.querySelector(".control")?.focus();
  }

  render() {
    if (!this.config) {
      logger.error("Missing form control configuration.");
      return formControl;
    }

    switch (this.config.type) {
      case "combobox":
        return formControlCombobox;
      case "select":
        return formControlSelect;
      default:
        return formControl;
    }
  }

  private handleChange(e: CustomEvent) {
    this.dispatchEvent(
      new CustomEvent("change", {
        detail: {
          id: this.config!.id,
          value: e.detail,
        },
      })
    );
  }

  private handleClose() {
    this.dispatchEvent(new CustomEvent("close"));
  }
}
